import React from 'react';
var SnippylyUserRequestTool = function (props) {
    var type = props.type;
    return (React.createElement("velt-user-request-tool", { type: type }));
};
export default SnippylyUserRequestTool;
